import { CheckboxGroup, Flex, ManagedCheckbox } from '@lokalise/louis';

import type { ProjectId } from '../../types';

type Option = { value: ProjectId; label: string };

const prepareIncomingValue = (projectIds: readonly ProjectId[], options: readonly Option[]): readonly string[] =>
    projectIds.reduce((acc, id) => {
        const option = options.find((opt) => opt.value === id);

        return option ? [...acc, option.value] : acc;
    }, [] as string[]);

interface IncludeOtherProjectStringsInputProps {
    value: readonly ProjectId[];
    options: readonly Option[];
    onChange: (value: readonly ProjectId[]) => void;
}

const IncludeOtherProjectStringsInput = ({ value, options, onChange }: IncludeOtherProjectStringsInputProps) => (
    <CheckboxGroup
        name="includeOtherProjectsStrings"
        value={prepareIncomingValue(value, options)}
        onChange={(event, val) => onChange(val)}
    >
        <Flex gap={3} direction="column">
            {options.map(({ label, ...rest }) => (
                <ManagedCheckbox key={rest.value} value={rest.value}>
                    {label}
                </ManagedCheckbox>
            ))}
        </Flex>
    </CheckboxGroup>
);
export default IncludeOtherProjectStringsInput;
